
  export default {
    name: 'NotFoundView'
  }
